import React from 'react';

import Button from 'components/shared/Button';
import Divider from 'components/shared/Divider';
import Text from 'components/shared/Typography/Text';

import s from './index.module.css';
import { IOfflineModeProps } from './types';

function OfflineMode({ onRead }: IOfflineModeProps) {
  return (
    <div className={s.wrapper}>
      <div className={s.title}>
        <Text accent isStrong className={s.titleText}>
          Heads up!
        </Text>
      </div>
      <Divider noMargin />
      <div className={s.body}>
        <Text accent className={s.bodyText}>
          Make sure to open this page on your mobile device before you travel. This will enable you to also have access
          to everything offline.
          <br />
          <br />
          <b>Note:</b> To access any documents while offline, please download them on your mobile device now.
        </Text>
        <div className={s.buttonWrapper}>
          <Button type="secondary" onClick={onRead}>
            Got it!
          </Button>
        </div>
      </div>
    </div>
  );
}

export default OfflineMode;
